/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Benefit_Guarantees_DescriptionInputs */

const en_business_benefit_guarantees_description = /** @type {(inputs: Business_Benefit_Guarantees_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`99% uptime`)
};

const es_business_benefit_guarantees_description = /** @type {(inputs: Business_Benefit_Guarantees_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`99% de disponibilidad`)
};

/**
* | output |
* | --- |
* | "99% uptime" |
*
* @param {Business_Benefit_Guarantees_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_benefit_guarantees_description = /** @type {((inputs?: Business_Benefit_Guarantees_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Benefit_Guarantees_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_benefit_guarantees_description(inputs)
	return en_business_benefit_guarantees_description(inputs)
});